const onboarding = [
  {
    tabName: "Application Form",
    page: [
      {
        name: "New Offline Merchant",
        path: "/onboarding/application-form/add-offline-merchant",
        authority: "PORTAL",
        rolePermission: "OBS_APPLICATION_FORM",
      },
      // {
      //   name: "Add Online Merchant",
      //   path: "/onboarding/application-form/add-online-merchant",
      //   authority: "PORTAL",
      // },
      // {
      //   name: "Add Device",
      //   path: "/onboarding/application-form/add-device",
      //   authority: "PORTAL",
      // },
      // {
      //   name: "Add Outlet",
      //   path: "/onboarding/application-form/add-outlet",
      //   authority: "PORTAL",
      // },
      // {
      //   name: "Add Offline Payment",
      //   path: "/onboarding/application-form/add-offline-payment",
      //   authority: "PORTAL",
      // },
      // {
      //   name: "Add Online Payment",
      //   path: "/onboarding/application-form/add-online-payment",
      //   authority: "PORTAL",
      // },
    ],
  },
  {
    tabName: "Application List",
    page: [
      {
        name: "All",
        path: "/onboarding/application-list/all",
        authority: "PORTAL",
        rolePermission: "OBS_APPLICATION_LIST",
      },
      {
        name: "Saved",
        path: "/onboarding/application-list/saved",
        authority: "PORTAL",
        rolePermission: "OBS_APPLICATION_LIST",
      },
      {
        name: "Processing",
        path: "/onboarding/application-list/processing",
        authority: "PORTAL",
        rolePermission: "OBS_APPLICATION_LIST",
      },
      {
        name: "Completed",
        path: "/onboarding/application-list/completed",
        authority: "PORTAL",
        rolePermission: "OBS_APPLICATION_LIST",
      },
      {
        name: "Rejected",
        path: "/onboarding/application-list/rejected",
        authority: "PORTAL",
        rolePermission: "OBS_APPLICATION_LIST",
      },
      {
        name: "Withdrawn",
        path: "/onboarding/application-list/withdrawn",
        authority: "PORTAL",
        rolePermission: "OBS_APPLICATION_LIST",
      },
      {
        name: "Pending Payment",
        path: "/onboarding/application-list/pending-payment",
        authority: "PORTAL",
        rolePermission: "OBS_APPLICATION_LIST",
      },
      {
        name: "Pending Installation",
        path: "/onboarding/application-list/pending-installation",
        authority: "PORTAL",
        rolePermission: "OBS_APPLICATION_LIST",
      },
    ],
  },
  {
    tabName: "Installation Confirmation Letter",
    page: [],
    path: "/onboarding/installation-confirmation-letter",
    authority: "PORTAL",
    rolePermission: "OBS_INSTALLATION_CONFIRMATION",
  },
  {
    tabName: "Approved KYC Application",
    page: [],
    path: "/onboarding/approved-kyc-application",
    authority: "PORTAL",
    rolePermission: "OBS_APPROVED_KYC_APPLICATION",
  },
  {
    tabName: "Merchant Document",
    page: [],
    path: "/onboarding/merchant-document",
    authority: "PORTAL",
    rolePermission: "OBS_MERCHANT_DOCUMENT",
  },
];

export default onboarding;
